import React from 'react'
import { HighlightList, PageSection } from '@superhi/design'

type Props = {
  items: React.ComponentProps<typeof HighlightList>['children']
}

const Overview: React.FC<Props> = ({ items = [] }) => (
  <PageSection title="What you'll learn" noBottomPadding>
    <HighlightList>{items}</HighlightList>
  </PageSection>
)

export default Overview
